import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GetProductsQueryResponse, GetProductQueryResponse, CreateProductCommand, UpdateProductCommand } from '../../interfaces/interfaces';
import { ProductsService } from '../products.service';
import { MaintainStockComponent } from '../maintain-stock/maintain-stock.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, CancelEvent, CellClickEvent, CellCloseEvent, DataStateChangeEvent, EditEvent, GridComponent, 
  GridDataResult, RemoveEvent, SaveEvent } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ReOrderProductComponent } from '../reorder-products/reorder-product.component';
import { Keys } from '@progress/kendo-angular-common';
//import { ProductService } from '../services/product.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

interface ProductResponse {
  id: number;
  title: string;
  stockCount: number;
  costPrice?: number;
  description?: string;
  itemsPerUnit?: number;
  modifiedBy?: string;
  modifiedDate?: string;
  stockAlert?: number;
  stockCountBy?: null | string;
  stockCountDate?: null | string;
  stockReOrderAmountLastBought?: null | number;
  stockReOrderAmountLastBoughtDate?: null | string;
  stockReOrderAmountSuggested?: number;
  stockReOrdered?: null | boolean;
  stockReOrderedBy?: null | string;
  stockWarning?: number;
  store?: null | string;
  supplierId?: number;
  supplierName?: null | string;
}

interface EditableProduct {
  id: number;
  title: string;
  stockCount: number;
  originalTitle: string;
  originalStockCount: number;
  changed?: boolean; 
}

@Component({
  selector: 'sdc-stock-count',
  templateUrl: './stock-count.component.html',
  styleUrls: ['./stock-count.component.scss']
})
export class StockCountComponent implements OnInit {

  jewelleryForm: UntypedFormGroup;
  isLoading = false;
  canEdit = false;
  public chosenJewellery: GetProductsQueryResponse;
  jewelleries = [];
  userName: string;
  role: string;

  dataset: any[] = [
    {id: 1, name: 'Ted Right', address: 'Wall Street'},
    {id: 2, name: 'Frank Honest', address: 'Pennsylvania Avenue'},
    {id: 3, name: 'Joan Well', address: 'Broadway'},
    {id: 4, name: 'Gail Polite', address: 'Bourbon Street'},
    {id: 5, name: 'Michael Fair', address: 'Lombard Street'},
    {id: 6, name: 'Mia Fair', address: 'Rodeo Drive'},
    {id: 7, name: 'Cora Fair', address: 'Sunset Boulevard'},
    {id: 8, name: 'Jack Right', address: 'Michigan Avenue'},
  ];

  dataset1: any[] = [];

  
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public newDataItem: CreateProductCommand;
  public editDataItem: GetProductQueryResponse;
  public isNew: boolean;
  public jewellery: GetProductQueryResponse;
  //public products: GetProductQueryResponse[] = [];
  public updateProductCommand: UpdateProductCommand;
  private updatedItems: UpdateProductCommand[] = [];

  private editedRowIndex: number;
  private editedProduct: UpdateProductCommand;

  
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  public gridStateAlert: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  public gridStateWarning: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  //public gridData: Observable<any>;
  public gridDataAlert: Observable<any>;
  public gridDataWarning: Observable<any>;
  //public gridData: any = process(this.products, this.gridState);

  public data: GetProductQueryResponse[] = [];

  products: EditableProduct[] = [];
  hasChanges = false;

  category: string = '';

  constructor(
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private productService: ProductsService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { 
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.category = (navigation.extras.state as { category: string }).category;
      console.log('Received category:', this.category);
    } else {
      // If no category is provided, redirect back to products
      this.router.navigate(['/products']);
      this.showMessage('No category specified');
    }
  }

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
    //this.role = localStorage.getitem('currentRole');
    //this.intialiseData();
    this.loadProducts();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    //alert("In State");
    this.gridState = state;
    //this.gridData = process(this.products, this.gridState);
    // this.gridData = this.productService.getAllProducts().pipe(
    //   map((data) => process(data.products, this.gridState))
    // );
  }

  
  intialiseData(): void {

    //alert("Initialise");
    // if (this.role == 'Stock')
    // {
    //   this.gridData = this.productService.getAllProducts().pipe(
    //     map((data) => process(data.products, this.gridState))
    //   );
    //   //this.gridData = this.productService.apiProductGet().pipe(
    //   //  map((data) => process(data.products.filter(x => x.store == 'DISHD'), this.gridState))
    //   //);
    // }
    // else if (this.role == 'Creams')
    // {
    //   this.gridData = this.productService.getAllProducts().pipe(
    //     map((data) => process(data.products, this.gridState))
    //   );
    // }
    // else {
    //   //this.gridData = process(this.data, this.gridState);
    //   this.gridData = this.productService.getAllProducts().pipe(
    //     map((data) => process(data.products, this.gridState))
    //   );
    // }
    
    // this.productService.getAllProducts().pipe(take(1)).subscribe({
    //   next: (response: GetProductsQueryResponse) => {
    //     //alert(this.role);
    //     if (this.role == 'Stock')
    //     {
    //       //response.products = response.products.filter(x => x.store == 'DISHD');
    //     }
    //     this.chosenJewellery = response;
    //     this.dataset1 = response.products;
    //     this.isLoading = false;
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     //alert(error);
    //     this.isLoading = false;
    //   }
    // });
  }

  saveAll(){
    alert("Test");
    for (let i = 0; i < 5; i++) {
      alert(this.dataset1[i].id + ' ' + this.dataset1[i].title + ' ' +  this.dataset1[i].stockCount);
      let category = <UpdateProductCommand>{ };
      category.id = this.dataset1[i].id;
      this.updateRepairEvent(category);
    }
  }

  updateRepairEvent(command: UpdateProductCommand): void {
    this.productService.updateProduct(command).pipe(take(1)).subscribe({
      next: () => {
        this.isLoading = false;
        //this.displayMessage('Supplier updated');
        //this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        this.isLoading = false;
      }
    });
    
  }

  updateJewellery(args: AddEvent): void {
    var sid = args.dataItem.id;
    this.jewellery = this.chosenJewellery.products.find(x => x.id === sid);
    console.log(this.jewellery);
    const dialogRef = this.dialog.open(MaintainStockComponent, {
      width: '1300px',
      data: this.jewellery,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData(); 
    });
  }

  loadProducts(): void {
    this.isLoading = true;
    this.productService.getProductByStore({ store: this.category}).subscribe({
      next: (response) => {
        console.log(response);
        this.products = response.products.map((product: ProductResponse) => ({
          id: product.id,
          title: product.title || '',
          stockCount: product.stockCount || 0,
          originalTitle: product.title,
          originalStockCount: product.stockCount
        }));
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading products:', error);
        this.isLoading = false;
        this.showMessage('Error loading products');
      }
    });
  }

  onFieldChange(product: EditableProduct): void {
    product.changed = product.stockCount !== product.originalStockCount;
    this.checkForChanges();
  }

  // onFieldChange(product: EditableProduct, event: any): void {
  //   const input = event.target;
  //   if (product.stockCount !== product.originalStockCount) {
  //     input.style.backgroundColor = '#fff3cd'; // Light yellow
  //   } else {
  //     input.style.backgroundColor = 'white';
  //   }
  //   this.checkForChanges();
  // }

  // onFieldChange(product: EditableProduct): void {
  //   const inputElement = document.querySelector(`input[data-id="${product.id}"]`) as HTMLInputElement;
  //   console.log(inputElement);
  //   if (inputElement) {
  //     inputElement.style.backgroundColor = 
  //       product.stockCount !== product.originalStockCount ? '#fff3cd' : 'white';
  //   }
  //   this.checkForChanges();
  // }

  checkForChanges(): void {
    this.hasChanges = this.products.some(product => 
      product.title !== product.originalTitle || 
      product.stockCount !== product.originalStockCount
    );
  }

  saveAllChanges(): void {
    const updatedProducts = this.products
      .filter(product => 
        product.title !== product.originalTitle || 
        product.stockCount !== product.originalStockCount
      )
      .map(product => ({
        id: product.id,
        title: product.title,
        stockCount: product.stockCount
      }));

    if (updatedProducts.length === 0) {
      this.showMessage('No changes to save');
      return;
    }

    this.isLoading = true;
    this.productService.updateProducts(updatedProducts).subscribe({
      next: () => {
        this.products.forEach(product => {
          product.originalTitle = product.title;
          product.originalStockCount = product.stockCount;
        });
        this.hasChanges = false;
        this.isLoading = false;
        this.showMessage('Changes saved successfully');
      },
      error: (error) => {
        console.error('Error saving changes:', error);
        this.isLoading = false;
        this.showMessage('Error saving changes');
      }
    });
  }

  private showMessage(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'top'
    });
  }

  get leftColumnProducts(): EditableProduct[] {
    return this.products.filter((_, index) => index % 2 === 0);
  }

  get rightColumnProducts(): EditableProduct[] {
    return this.products.filter((_, index) => index % 2 === 1);
  }
}
